(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const block = doc.querySelector('.complementary-products');
            if (block) {
              this.innerHTML = block.outerHTML;
              const track = this.querySelector('.cart-reco__track');
              if (track) window.updateCartRecoArrows && window.updateCartRecoArrows(track);
            }
          })
          .catch(() => {});
      }
    });
  }

  /* Cart recommendations slider: arrows + swipe */
  if (!window.cartRecoSliderReady) {
    window.cartRecoSliderReady = true;

    window.updateCartRecoArrows = (track) => {
      const wrap = track.closest('.cart-reco');
      if (!wrap || !track.clientWidth) return;
      const prev = wrap.querySelector('.cart-reco__arrow[data-dir="-1"]');
      const next = wrap.querySelector('.cart-reco__arrow[data-dir="1"]');
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.cart-reco__arrow');
      if (!button) return;
      event.preventDefault();
      const track = button.closest('.cart-reco').querySelector('.cart-reco__track');
      const slide = track.querySelector('.cart-reco__slide');
      const step = slide ? slide.offsetWidth + 12 : track.clientWidth * 0.85;
      track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
    });

    document.addEventListener('scroll', (event) => {
      if (event.target.classList && event.target.classList.contains('cart-reco__track')) {
        window.updateCartRecoArrows(event.target);
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();
})();
